import GeoMMM from "./GeoMMM";

export default GeoMMM;
